import { useContext, useEffect, useState } from "react";
import styles from "./porfile.module.css";
import { getUserProfile, saveUserProfile } from "../../Api/Services/Account";
import { UserProfileDt } from "../../Models/AccountModel";
import { AccountContext } from "../../Store/Account.store";
import { useNavigate } from "react-router-dom";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import { fetchCompanyGroups } from "../../Api/Services/Suppliers";
import Select from "react-select";

export default function Profile() {
    const {accountData} = useContext(AccountContext);
    const [profileData, setProfileData] = useState<UserProfileDt>({} as UserProfileDt);
    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [companyGroupOptions, setCompanyGroupOptions] = useState<{value: number, label: string}[]>([]);
    const [selectedCompanyGroup, setSelectedCompanyGroup] = useState<{value: number, label: string} | null>(null);
    const naviagte = useNavigate();

    useEffect(() => {
        getProfileData();
        getCompanyGroup();
    }, []);

    useEffect(() => {
        if (selectedCompanyGroup == null) {
            if (companyGroupOptions.length > 0 && profileData.companyGroupId != undefined) {
                setSelectedCompanyGroup(companyGroupOptions.find((x) => x.value == profileData.companyGroupId) || null);
            }
        }
    },[companyGroupOptions, profileData]);
    
    const getProfileData = () => {
        getUserProfile().then((data) => {
            if (Object.keys(data).length == 0) {
                naviagte('/sign-in');
            }else{
                setProfileData(data);
            }
        })
    }

    const getCompanyGroup = () => {
        fetchCompanyGroups().then((newdata) => {
            if (newdata.length > 0) {
                setCompanyGroupOptions(newdata.map((x) => ({value: x.id, label: x.name})));
            }
        });
    }

    const saveProfileData = () => {
        setLoading(true);
        saveUserProfile(profileData).then(() => {
            setLoading(false);
        });
    }

    const validateEmail = (email: string) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (email == "" || emailPattern.test(email)) {
            setProfileData({...profileData, contactEmail: email})
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    }

    const validatePhone = (phone: string) => {
        const phonePattern = /^\+?[1-9]\d{1,14}$/;
        if (phone == "" || phonePattern.test(phone)) {
            setProfileData({...profileData, contactPhone: phone})
            setPhoneError(false);
        } else {
            setPhoneError(true);
        }
    }
    
    return (
        <div className={styles.container}>
            <h1>Edit my account profile.</h1>
            {loading && <LoadingIcon />}
            {accountData.isauthenticated == true && <form>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="companyName">Name of the company</label>
                    <input className={styles.input} type="text" name="companyName" id="companyName" autoComplete="off" value={profileData.companyName} onBlur={(e) => setProfileData({...profileData, companyName: e.target.value})} onChange={(e) => setProfileData({...profileData, companyName: e.target.value})}/>
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="companyGroupName">Company Group</label>                    
                    <Select 
                    className="basic-single"
                    classNamePrefix="select"
                    name="companyGroupName"
                    id="companyGroupName"
                    placeholder="None selected"
                    value={selectedCompanyGroup}
                    options={companyGroupOptions}
                    onChange={(e) => {setProfileData({...profileData, companyGroupId: e?.value, companyGroupName: e?.label})}}
                    /> 
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="contactName">Contact person name</label>
                    <input className={styles.input} type="text" name="contactName" id="contactName" autoComplete="off" value={profileData.contactName} onBlur={(e) => setProfileData({...profileData, contactName: e.target.value})} onChange={(e) => setProfileData({...profileData, contactName: e.target.value})}/>
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="contactTitle">Contact position/title in the company</label>
                    <input className={styles.input} type="text" name="contactTitle" id="contactTitle" autoComplete="off" value={profileData.contactTitle} onBlur={(e) => setProfileData({...profileData, contactTitle: e.target.value})} onChange={(e) => setProfileData({...profileData, contactTitle: e.target.value})}/>
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="contactEmail">Contact email (We will use this email in communication with you)</label>
                    <input className={`${styles.input} ${emailError ? "error" : ""}`} type="text" name="contactEmail" id="contactEmail" autoComplete="off" value={profileData.contactEmail} onBlur={(e) => validateEmail(e.target.value)} onChange={(e) => setProfileData({...profileData, contactEmail: e.target.value})}/>
                    {emailError && <span className="error_text">Email is not valid</span>}
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="contactPhone">Contact phone</label>
                    <input className={`${styles.input} ${phoneError ? "error" : ""}`} type="text" name="contactPhone" id="contactPhone" autoComplete="off" value={profileData.contactPhone} onBlur={(e) => validatePhone(e.target.value)} onChange={(e) => setProfileData({...profileData, contactPhone: e.target.value})}/>
                    {phoneError && <span className="error_text">Phone number is not valid</span>}
                </div>
                <div className={styles.group}>
                    <label className={styles.label} htmlFor="companyWebsite">Company website</label>
                    <input className={styles.input} type="text" name="companyWebsite" id="companyWebsite" autoComplete="off" value={profileData.companyWebsite} onBlur={(e) => setProfileData({...profileData, companyWebsite: e.target.value})} onChange={(e) => setProfileData({...profileData, companyWebsite: e.target.value})}/>
                </div>
                <button type="button" className="button" onClick={saveProfileData}>Save</button>
            </form>}
        </div>
    )
}
